import { createSelector } from 'reselect'
import format from 'date-fns/format'

import { formatDateWithShortMonth } from '@offerzen/utils'

import { parseDate } from '@/core/helpers/dateTimeHelper'
import { closeReasons } from '../helpers/closeReasonsHelper'

export const getPosition = state => state.views.positionsDashboard_LEGACY.positions.member
export const getPositionUtils = state => state.views.positionsDashboard_LEGACY.positions.utils

export const detailsInitialValues = createSelector([getPosition], ({ attachment, ...position }) => ({
  name: position.name,
  openings: Number(position.openings),
  description: position.description,
  attachment: attachment && {
    id: attachment.id,
    name: attachment.file_name,
    url: attachment.file_url,
  },
}))

export const templatesInitialValues = createSelector([getPosition], position => ({
  message_template: position.message_template,
}))

export const settingsInitialValues = createSelector([getPosition], ({ subscribed_member_profiles }) => ({
  subscribed_member_profile_ids: subscribed_member_profiles.reduce(
    (accumulator, member) => ({
      ...accumulator,
      [member.id]: true,
    }),
    {},
  ),
}))

export const positionMetadata = createSelector([getPosition], ({ member_profile, ...position }) => {
  let closedReason = position.close_reason && closeReasons.find(reason => reason.value === position.close_reason).label
  if (position.close_reason_other_description) {
    closedReason = closedReason.concat(`: ${position.close_reason_other_description}`)
  }

  return {
    createdAtLabel: formatDateWithShortMonth(position.created_at),
    updatedAtLabel: position?.updated_at && format(parseDate(position.updated_at), "d MMM. yyyy 'at' HH:mm"),
    creatorName: member_profile ? member_profile.name : 'User',
    closedReason,
    closedAt: formatDateWithShortMonth(position.updated_at),
  }
})

export const positionNotFound = createSelector([getPositionUtils], view => !!view.fetchDetailError)
